{
  "fr": {
    "announcement": {
      "actions": {
        "delete_announcement": "Supprimer Annonce",
        "edit": "Modifier",
        "new": "Annonce",
        "pin": "Épingler en haut",
        "save": "Sauvegarder",
        "submit": "Poster",
        "unpin": "Détacher du haut"
      },
      "attributes": {
        "description": "Description"
      },
      "labels": {
        "customers": "",
        "for": "pour les clients",
        "image_tab": "Image",
        "notSeenYet": "Pas encore vu",
        "seen": "Vu",
        "seenByCount": "Vu par {count} sur {total}",
        "now": "Présent",
        "sharedWithPrefix": "Partagé avec",
        "sharedWithProject": "Partagé avec {units} de {project}",
        "allUnits": "toutes les unités",
        "someUnits": "certaines unités",
        "pinned": "Cette annonce s'affiche en haut de la page du client.",
        "pinnedBadge": "Épinglé",
        "start": "Début",
        "unitsCount": "Une Unité | {count} Unités",
        "video_tab": "vidéo",
        "youtube_video": "Lien Vidéo YouTube"
      },
      "name": "Annonce",
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Bientôt, vous trouverez des annonces sur le site de construction sur le dashboard.",
            "title": "Recevez vos nouvelles ici!"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Accueillir vos clients ou partagez une mise à jour sur le projet.",
            "title": "Créer votre première Annonce"
          },
          "none": {
            "project_required": "Sélectionnez un projet",
            "selectProject": "Sélectionnez un projet et commencez à créer !",
            "subtitle": "Accueillez vos clients ou partagez une mise à jour sur n'importe quel projet."
          },
          "paste_video_url": "Coller votre lien YouTube ici"
        }
      },
      "toasts": {
        "create": "Annonce publiée",
        "delete": "Annonce supprimée",
        "invalid_video": "Ce n'est pas une vidéo YouTube valide",
        "update": "Annonce modifiée"
      },
      "validation": {
        "pleaseAddContent": "Ajouter une image, une vidéo ou description"
      }
    }
  }
}
